module.exports = __webpack_public_path__ + "cd455783/img/question-icon.06c20c5d.svg";